goog.provide("shadow.js.shim.module$src$svg$wpp$content$action_svg$default");
shadow.js.shim.module$src$svg$wpp$content$action_svg$default = shadow.js.shim.module$src$svg$wpp$content$action_svg.default;
